import PropTypes from 'prop-types';
import React from 'react';
import classnames from 'classnames';

import { CoreParagraph } from '../library/paragraph';
import './paragraph.scss';

export function Paragraph(props) {
	return (
		<CoreParagraph
			className={
				classnames(
					props.size,
					props.className,
					{
						light: props.light,
						centered: props.centered,
						strong: props.strong
					}
				)
			}
			dangerouslySetInnerHTML={props.dangerouslySetInnerHTML}
		>
			{props.children}
		</CoreParagraph>
	);
}

Paragraph.propTypes = {
	className: PropTypes.string,
	size: PropTypes.oneOf(['tiny', 'small', 'medium', 'large', 'extra-large']),
	light: PropTypes.bool,
	centered: PropTypes.bool,
	children: PropTypes.node,
	dangerouslySetInnerHTML: PropTypes.object,
	strong: PropTypes.bool
};

export default Paragraph;
